export const normalizeString = (value: string): string => value.trim().replace(/\s+/g, " ");

export const normalizeOrNull = (value: string | null | undefined): string | null => {
  if (value == null) return null;
  const normalized = normalizeString(value);
  return normalized.length === 0 ? null : normalized;
};
